/** PROTOTYPE seed — in memory only. */

export type RefKind = 'person' | 'event' | 'planBlock'

export type ProtoRef = {
	id: string
	kind: RefKind
	name: string
}

export const EVENT: ProtoRef = {
	id: 'event-sunday',
	kind: 'event',
	name: 'Sunday Gathering',
}

export const PEOPLE: ProtoRef[] = [
	{ id: 'person-maya', kind: 'person', name: 'Maya Chen' },
	{ id: 'person-jordan', kind: 'person', name: 'Jordan Hale' },
	{ id: 'person-sam', kind: 'person', name: 'Sam Ortiz' },
	{ id: 'person-priya', kind: 'person', name: 'Priya Shah' },
	{ id: 'person-lee', kind: 'person', name: 'Lee Okonkwo' },
	{ id: 'person-ava', kind: 'person', name: 'Ava Brooks' },
]

export const BLOCKS: ProtoRef[] = [
	{ id: 'block-welcome', kind: 'planBlock', name: 'Welcome' },
	{ id: 'block-teaching', kind: 'planBlock', name: 'Teaching' },
	{ id: 'block-response', kind: 'planBlock', name: 'Response' },
]

export function allRefs(): ProtoRef[] {
	return [EVENT, ...PEOPLE, ...BLOCKS]
}

export function findRef(id: string): ProtoRef | undefined {
	return allRefs().find((r) => r.id === id)
}
